import { render } from "./localeTools.vue?vue&type=template&id=6c178cf1"
import script from "./localeTools.vue?vue&type=script&lang=js"
export * from "./localeTools.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./localeTools.vue?vue&type=style&index=0&id=6c178cf1&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__